import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TipoIngresoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_ingreso {
            obtenerTodos {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_ingreso.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
TipoIngresoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TipoIngresoService_Factory() { return new TipoIngresoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TipoIngresoService, providedIn: "root" });
